import * as React from 'react'
import cx from 'classnames'
import styles from './RadioButtonGroup.sass'

/**
 * Radio Button Group Size.
 */
export type RadioButtonGroupSize = 'big' | 'big-wide' | 'medium'

export interface RadioButtonGroupProps {
  children: React.ReactNode
  className?: string
  size?: RadioButtonGroupSize
  /**
   * Useful when used in a Form.
   */
  label?: string
}

export function RadioButtonGroup({
  size = 'big',
  className,
  children,
  label,
}: RadioButtonGroupProps) {
  return (
    <>
      {label && <div className={styles.radioButtonGroupLabel}>{label}</div>}
      <div
        className={cx(
          styles.radioButtonGroup,
          styles[size] || styles.big,
          className,
        )}
      >
        {children}
      </div>
    </>
  )
}

export interface RadioButtonItemProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  active: boolean
  className?: string
  dataTest?: string
  disabled?: boolean
}

export const RadioButtonItem = React.forwardRef(
  (
    {
      children,
      className,
      dataTest,
      active,
      onClick,
      disabled,
      ...rest
    }: RadioButtonItemProps,
    ref: React.Ref<any>,
  ) => (
    <button
      disabled={disabled}
      ref={ref}
      data-test={dataTest}
      onClick={disabled ? undefined : onClick}
      type="button"
      className={cx(
        styles.radioButtonGroupItem,
        active && styles.active,
        disabled && styles.disabled,
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  ),
)
